import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatTime, prettyDate } from "@/lib/api";

export const LeaveResult = ({ cancelled, onDone }) => (
  <div className="space-y-4" data-testid="leave-result">
    {cancelled.length === 0 ? (
      <p className="text-sm text-muted-foreground" data-testid="leave-result-none">No appointments were booked in this period.</p>
    ) : (
      <>
        <p className="text-sm text-muted-foreground">
          These {cancelled.length} appointment(s) were cancelled. Patients without an email were not notified, so please call them.
        </p>
        <ul className="divide-y divide-slate-100 rounded-xl border border-slate-100">
          {cancelled.map((a) => (
            <li key={a.reference} className="px-4 py-3 text-sm flex items-center justify-between gap-3" data-testid={`leave-cancelled-${a.reference}`}>
              <div>
                <p className="font-semibold text-[#1A252C]">{a.name}</p>
                <p className="text-muted-foreground">{a.clinic_name} · {prettyDate(a.date)} · {formatTime(a.time)}</p>
                <p className="text-xs text-muted-foreground">{a.email ? "Emailed" : "No email, please call"}</p>
              </div>
              <a href={`tel:+91${a.phone}`} className="inline-flex items-center gap-1 text-primary font-medium whitespace-nowrap"><Phone className="h-4 w-4" /> {a.phone}</a>
            </li>
          ))}
        </ul>
      </>
    )}
    <Button className="w-full rounded-full" onClick={onDone} data-testid="leave-result-done-btn">Done</Button>
  </div>
);
